import React, { MouseEventHandler, useCallback } from "react";

import { GroupButton } from "./GroupButton";
import { IPickerButton, PickerItem } from "./Picker.types";
import { SelectionCanceller } from "./SelectionCanceller";

interface IItemButtonProps<TTab extends string, TGroup extends string> {
    item: IPickerButton<TTab, TGroup>;
    selected: boolean;
    setIndexedItem: (item: PickerItem<TTab, TGroup>) => void;
    showBadge?: boolean;
    onSelect?: (item: IPickerButton<TTab, TGroup>) => void;
}

export function ItemButton<TTab extends string, TGroup extends string>(
    props: IItemButtonProps<TTab, TGroup>,
) {
    const {
        item,
        onSelect,
        selected,
        setIndexedItem,
        showBadge = true,
    } = props;
    const { onClick, disabled } = item;

    const setIndex = useCallback(
        () => setIndexedItem(item),
        [setIndexedItem, item],
    );

    const handleClick = useCallback<
        MouseEventHandler<HTMLButtonElement>
    >(() => {
        const canceler = new SelectionCanceller();
        onClick?.call(item, canceler);
        if (!canceler.isCancelled) {
            onSelect?.(item);
        }
    }, [item, onSelect, onClick]);

    const hasInfo = "InfoComponent" in item;

    return (
        <GroupButton
            disabled={disabled}
            hasInfo={hasInfo}
            onClick={handleClick}
            icon={item.icon}
            selected={selected}
            onFocus={setIndex}
            badge={showBadge && item.badge}
            checked={item.checked}
        >
            {item.label}
        </GroupButton>
    );
}
